import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';

import { useTranslation } from '@common/hooks/translation';
import TicketSkeleton from '@common/components/ticketSkeleton';
import Money from '@app/dev/terminal/components/money';

import { BetStatus } from '../components/betStatus';

const TicketDetailsDeposit = ({ ticket }) => {
  const t = useTranslation();

  return (
    <TicketSkeleton dark>
      <div className="ticket-section">
        <div className="ticket-info-row">
          <p>{t('Status')}</p>
          <BetStatus data={ticket} />
        </div>
        <div className="ticket-info-row">
          <p>{t('Id')}</p>
          <span>{ticket.dataFromSwarm.document_id}</span>
        </div>
        <div className="ticket-info-row">
          <p>{t('Date')}</p>
          <span>{moment(ticket.dataFromSwarm.date).format('DD/MM/YYYY HH:mm:ss')}</span>
        </div>
        <div className="ticket-info-row">
          <p>{t('Bet Type')}</p>
          <p>-</p>
        </div>
      </div>

      <div className="ticket-section">
        <div className="ticket-info-row">
          <p>{t('Total odd')}</p>
          <p>-</p>
        </div>
        <div className="ticket-info-row">
          <p>{t('Amount')}</p>
          <p><Money amount={ticket.dataFromSwarm.amount} /></p>
        </div>
      </div>
    </TicketSkeleton>
  );
};

TicketDetailsDeposit.propTypes = {
  ticket: PropTypes.object.isRequired,
};

export default TicketDetailsDeposit;
